import { useEffect, useMemo, useState } from "react"
import { useField } from "formik"
import { DynamicConfigKey, DynamicConfigField } from "../../form/formTypes"

type DeliveryFields = {
    deliveryLocations?: DynamicConfigField
    otherDeliveryLocation?: DynamicConfigField
}

export function useDeliveryLocationToggle(sections: { groups: { fields: DynamicConfigField[] }[] }[]) {
    const deliveryFields = useMemo<DeliveryFields>(() => {
        const allFields = sections.flatMap((s) => s.groups.flatMap((g) => g.fields))
        return {
            deliveryLocations: allFields.find((f) => f.key === DynamicConfigKey.DELIVERY_LOCATIONS),
            otherDeliveryLocation: allFields.find((f) => f.key === DynamicConfigKey.OTHER_DELIVERY_LOCATION),
        }
    }, [sections])

    const [{ value: deliveryLocationsValue }, , deliveryLocationsHelpers] = useField(
        DynamicConfigKey.DELIVERY_LOCATIONS,
    )

    const [{ value: otherDeliveryLocationValue }, , otherDeliveryLocationHelpers] = useField(
        DynamicConfigKey.OTHER_DELIVERY_LOCATION,
    )

    const [showOtherLocationField, setShowOtherLocationField] = useState<boolean>(() => {
        const hasLocations = !!deliveryFields.deliveryLocations
        const hasOther = !!deliveryFields.otherDeliveryLocation
        return (!hasLocations && hasOther) || (hasLocations && !hasOther)
    })

    useEffect(() => {
        if (deliveryLocationsValue) {
            otherDeliveryLocationHelpers.setValue("")
            setShowOtherLocationField(false)
        }
    }, [deliveryLocationsValue])

    useEffect(() => {
        if (showOtherLocationField) {
            deliveryLocationsHelpers.setValue("")
        }
    }, [otherDeliveryLocationValue, showOtherLocationField])

    useEffect(() => {
        if (otherDeliveryLocationValue) {
            setShowOtherLocationField(true)
        }
    }, [otherDeliveryLocationValue])

    return { deliveryFields, showOtherLocationField, setShowOtherLocationField }
}
